import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-22',
  templateUrl: './22.component.html',
  styleUrls: ['./22.component.scss'],
})
export class VbGeneral22Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
